import { useCallback, useMemo } from 'react';

import { capitalize } from 'lodash';

import { SpaceTypeEnum } from 'src/common/external/bambi-api/bambiApi';
import { ItemSelector } from 'src/common/ItemSelector/ItemSelector';
import { spaceTypes } from 'src/common/spaceTypes';

const sortedSpaceTypes = spaceTypes.sort();
const spaceTypeWithId = sortedSpaceTypes.map((spaceType) => ({
  id: spaceType,
  label: capitalize(spaceType),
}));

export function SpaceTypeFilter({
  selectedSpaceTypeIds,
  onSpaceTypeChange,
}: {
  selectedSpaceTypeIds: SpaceTypeEnum[];
  onSpaceTypeChange: (spaceTypeIds: SpaceTypeEnum[]) => void;
}) {
  const selectedSpaceTypes = useMemo(() => {
    return selectedSpaceTypeIds.map((id) => ({
      id,
      label: capitalize(id),
    }));
  }, [selectedSpaceTypeIds]);

  const handleSelectionChange = useCallback(
    (spaceTypes: { id: SpaceTypeEnum; label: string }[]) => {
      onSpaceTypeChange(spaceTypes.map((spaceType) => spaceType.id));
    },
    [onSpaceTypeChange]
  );

  return (
    <ItemSelector
      items={spaceTypeWithId}
      selectedItems={selectedSpaceTypes}
      onSelectionChange={handleSelectionChange}
      getItemLabel={(spaceType) => spaceType.label}
      dataTestId="space-type-filter-search"
      noItemsText="No space types found."
    />
  );
}
